import { IPayrollService } from '../entities/IPayrollService';
import { IPayrollRepository } from '../entities/IPayrollRepository';
import {
  CreateProcessPayrollFileAuthorizationRequest,
  CreateProcessPayrollFileAuthorizationResponse,
  PayrollFileType,
  PayrollTotalAmount,
  PayrollUploadFileTypeResponse,
  ProcessPayrollAuthorizationResponse,
  Payroll,
  PayrollDetails,
  PayrollUploadFileTypeRequest,
  PayrollExecuteVopResponse,
  PayrollExecuteVopRequestBody,
} from '../entities/types';

export class PayrollServiceImpl implements IPayrollService {
  itemRepo: IPayrollRepository;

  constructor(ir: IPayrollRepository) {
    this.itemRepo = ir;

    this.ProcessPayrollAuthorization = this.ProcessPayrollAuthorization.bind(this);
    this.UploadFile = this.UploadFile.bind(this);
    this.CreateProcessPayrollFileAuthorization = this.CreateProcessPayrollFileAuthorization.bind(this);
    this.GetPayrollTotalAmount = this.GetPayrollTotalAmount.bind(this);
    this.GetPayrollList = this.GetPayrollList.bind(this);
    this.GetPayrollFileTypes = this.GetPayrollFileTypes.bind(this);
    this.GetPayrollDetails = this.GetPayrollDetails.bind(this);
    this.DeletePayroll = this.DeletePayroll.bind(this);
    this.ExecuteVop = this.ExecuteVop.bind(this);
  }

  ProcessPayrollAuthorization(data: {
    customerId: number;
    requestId: string;
  }): Promise<ProcessPayrollAuthorizationResponse> {
    return this.itemRepo.ProcessPayrollAuthorization(data.customerId, data.requestId);
  }

  UploadFile(request: PayrollUploadFileTypeRequest): Promise<PayrollUploadFileTypeResponse> {
    const { customerId, ...data } = request;
    return this.itemRepo.UploadFile(customerId, data);
  }

  ExecuteVop(data: PayrollExecuteVopRequestBody): Promise<PayrollExecuteVopResponse> {
    return this.itemRepo.ExecuteVop(data);
  }

  CreateProcessPayrollFileAuthorization(
    data: CreateProcessPayrollFileAuthorizationRequest,
  ): Promise<CreateProcessPayrollFileAuthorizationResponse> {
    const { customerId, fileId } = data;
    return this.itemRepo.CreateProcessPayrollFileAuthorization(customerId, fileId);
  }

  GetPayrollTotalAmount(payrollBulkHeaderId: number): Promise<PayrollTotalAmount> {
    return this.itemRepo.GetPayrollTotalAmount(payrollBulkHeaderId);
  }

  GetPayrollFileTypes(): Promise<PayrollFileType[]> {
    return this.itemRepo.GetPayrollFileTypes();
  }

  GetPayrollList({
    customerId,
    dateFrom,
    dateTo,
  }: {
    customerId: number;
    dateFrom: string;
    dateTo: string;
  }): Promise<Payroll[]> {
    return this.itemRepo.GetPayrollList(customerId, dateFrom, dateTo);
  }

  GetPayrollDetails(data: { customerId: number; fileId: number }): Promise<PayrollDetails> {
    return this.itemRepo.GetPayrollDetails(data.customerId, data.fileId);
  }

  DeletePayroll(payrollBulkHeaderId: number): Promise<any> {
    return this.itemRepo.DeletePayroll(payrollBulkHeaderId);
  }
}
